import React, { useEffect, useState } from 'react'
import className from 'classnames/bind'
import { useHistory } from 'react-router'

import style from './ToastMessage.module.scss'

import useToast from '@Hooks/myhouse/useToast'
import { TOAST_AFTER_EVENT } from '@Root/contants/myhouseToast'
import InsurancePromotionToast from '@Components/atoms/InsurancePromotionToast'

const cx = className.bind(style)

const ToastMessage: React.FC = () => {
  const history = useHistory()
  const { toast, hide } = useToast()

  const { isShow, message, path, afterEvent, isPromotion } = toast

  const [timeoutId, setTimeoutId] = useState(0)

  useEffect(() => {
    /* 무료보험 프로모션 추가부분 시작 */
    if (isPromotion) {
      window.clearTimeout(timeoutId)

      setTimeoutId(
        window.setTimeout(() => {
          hide()
          window.clearTimeout(timeoutId)
        }, 3000),
      )
      return
    }
    /* 무료보험 프로모션 추가부분 끝 */
    if (isShow) {
      window.clearTimeout(timeoutId)

      setTimeoutId(
        window.setTimeout(() => {
          hide()
          if (afterEvent === TOAST_AFTER_EVENT.HISTORY_PUSH && path) {
            history.push(path)
          }
          if (afterEvent === TOAST_AFTER_EVENT.HISTORY_REPLACE && path) {
            history.replace(path)
          }
          if (afterEvent === TOAST_AFTER_EVENT.LOCATION_HREF && path) {
            window.location.href = path
          }
          if (afterEvent === TOAST_AFTER_EVENT.HISTORY_BACK) {
            history.goBack()
          }
          if (afterEvent === TOAST_AFTER_EVENT.LOCATION_HREF_REFERRER) {
            window.location.href = document.referrer
          }

          window.clearTimeout(timeoutId)
        }, 1500),
      )
      return
    }
  }, [isShow, isPromotion, path])

  /*무료보험 프로모션 추가부분 시작*/
  if (isShow && isPromotion) {
    return <InsurancePromotionToast message={message} />
  }
  /*무료보험 프로모션 추가부분 끝*/

  return (
    <>
      {/* 메시지 노출 상태일 땐 body, 또는 #root에 is-popup 클래스 추가 */}
      {isShow && (
        <div className={`${cx('dimmed')} is-popup`}>
          <div className={cx('myhouse_popup', 'type_delete')}>
            <div className={cx('myhouse_popup_inner')}>
              <p className={cx('myhouse_popup_text')}>{message}</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ToastMessage
